/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { IPropertyConverter, JsonValue, TaJson } from "ta-json";

import {
    BooleanMemberCondition,
    MemberCondition,
    NoAncestorMemberCondition,
    RelationMemberCondition,
    StringMemberCondition,
} from "../contracts/base";
import { InvalidOperationError } from "../errors/invalid-operation-error";

export class MemberConditionConverter implements IPropertyConverter {
    /**
     * Serializes a MemberCondition instance into JSON Value.
     *
     * @param value - A MemberCondition instance
     *
     * @returns An JSON Value.
     */
    serialize(value: MemberCondition): JsonValue {
        return TaJson.serialize(value) as JsonValue;
    }

    /**
     * Deserializes a JSON Value into a MemberCondition instance.
     *
     * @param value - A JSON Value
     *
     * @returns A MemberCondition instance.
     */
    deserialize(value: JsonValue): MemberCondition {
        if (!value) {
            throw new InvalidOperationError("Can't deserialize falsy value.");
        } else if (typeof value !== "object" || value instanceof Array) {
            throw new InvalidOperationError(
                `Expected a value of type 'object', but value was of type '${typeof value}'.`
            );
        }
        const obj = typeof value === "string" ? JSON.parse(value) : value;

        if (obj.definitionId) {
            return TaJson.deserialize<NoAncestorMemberCondition>(value, NoAncestorMemberCondition);
        } else if (typeof obj.value === "string") {
            return TaJson.deserialize<StringMemberCondition>(value, StringMemberCondition);
        } else if (typeof obj.value === "boolean") {
            return TaJson.deserialize<BooleanMemberCondition>(value, BooleanMemberCondition);
        } else if (obj.entityId) {
            return TaJson.deserialize<RelationMemberCondition>(value, RelationMemberCondition);
        } else {
            throw new InvalidOperationError("Not a known condition format");
        }
    }
}
